import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useDraftOrderApprovalSend = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ orderNo, poNo }) =>
      callApi({
        path: "draftordercard",
        command: "sendapproval",
        data: JSON.stringify({
          data: { filter: { noFilter: orderNo }, order: { poNo: poNo } },
        }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orderListState"] });
    },
  });
};
